import * as React from 'react';

type SearchInputProps = {
    onSearch: (e: React.SyntheticEvent<HTMLButtonElement | HTMLInputElement>) => void;
    setSearchString: (searchString: string) => void;
    searchString: string;
    showEmptyResult: boolean;
    customPlaceholder: string | null;
};
export const SearchInput = ({ onSearch, setSearchString, searchString, showEmptyResult, customPlaceholder }: SearchInputProps) => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchString(e.target.value);
    };
    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 13) { // ENTER
            onSearch(e);
            return;
        }

    };

    return (
        <div className="row pb-5" >
            <div className="col-12 col-md-8 offset-md-2">
                <div className="search-box">
                    <input
                        type="text"
                        placeholder={customPlaceholder || 'Sök företagskunskap!'}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        value={searchString}
                    />
                    <button type="button" className=" bl-btn-darkblue bl-search" onClick={onSearch}>
                        <div className="search-icon-32"></div>
                    </button>
                </div>
            </div>
            <div className="col-12 col-md-8 offset-md-2 alert-container">
                {showEmptyResult && <div className={'alert alert-warning text-center no-result'}>
                    Inga resultat matchade din sökning
                </div>}
            </div>
        </div>
    );
};